<template>
  <article id="content">

    <btnXml :nota="this.nota" :component="this.component" v-if="this.component.enable.downXML"></btnXml>
    <btnPdf :nota="this.nota" :component="this.component" :pathPdfMotor="false" v-if="this.component.enable.downPdf"></btnPdf>
    <btnIptu :nota="this.nota" :component="this.component" v-if="this.component.enable.downIptu"></btnIptu>
    <btnPdf :nota="this.nota" :component="this.component" :pathPdfMotor="true" v-if="this.component.name.toLowerCase().indexOf('nfse') != -1 && this.component.enable.downPdf"></btnPdf>
  </article>
</template>
<script>
import btnXml from "./btnXml/BtnXml.vue";
import btnPdf from "./btnPdf/BtnPdf.vue";
import btnIptu from "./btnIptu/BtnIptu.vue"

export default {
  components: {
    btnXml: btnXml,
    btnPdf: btnPdf,
    btnIptu:btnIptu
  },
  props: ["nota", "component"],
  data: () => ({
    direction: "right",
    fab: false,
    fling: false,
    hover: false,
    tabs: true,
    top: false,
    right: false,
    bottom: false,
    left: false,
    transition: "slide-x-transition"
  }),
  updated: function () {
    this.$nextTick(function () { });
  },
  computed: {
    activeFab() {
      switch (this.tabs) {
        case "one":
          return { class: "purple", icon: "account_circle" };
        case "two":
          return { class: "red", icon: "edit" };
        case "three":
          return { class: "green", icon: "keyboard_arrow_up" };
        default:
          return {};
      }
    }
  },
  watch: {
    top(val) {
      this.bottom = !val;
    },
    right(val) {
      this.left = !val;
    },
    bottom(val) {
      this.top = !val;
    },
    left(val) {
      this.right = !val;
    }
  },
  methods: {}
};
</script>
<style scoped>
#content {
  display: inline-block;
  z-index: 2;
}

a {
  text-decoration: none;
  margin-top: 3px;
}

#ico {
  color: grey !important;
  transition: color 1 linear;
}

#ico:hover {
  color: #01579b !important;
}

.v-btn {
  margin: 2px 2px !important;
}</style>


// WEBPACK FOOTER //
// src/components/dataTable/commonTable/coluna_actions/btnDownload/BtnDownload.vue